import { cn } from '@/lib/utils'

/** A sphere from the board's illustrations. The board draws it differently in each theme. */
export function Sphere({
  name,
  className,
}: {
  name: 'sphere-lg' | 'sphere-sm'
  className: string
}) {
  const placed = cn('pointer-events-none absolute', className)

  return (
    <>
      <img
        src={`/images/vip-card/${name}.svg`}
        alt=""
        aria-hidden
        className={cn(placed, 'dark:hidden')}
      />
      <img
        src={`/images/vip-card/${name}-dark.svg`}
        alt=""
        aria-hidden
        className={cn(placed, 'hidden dark:block')}
      />
    </>
  )
}
